import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { cn } from "../../../../lib/utils";

export function SideBadge({ side }) {
  const isBuy = side === "B";
  const Icon = isBuy ? ArrowUpRight : ArrowDownRight;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded px-1.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider",
        isBuy ? "bg-green-500/10 text-green-500" : "bg-red-500/10 text-red-500",
      )}
    >
      <Icon className="h-3 w-3" />
      {isBuy ? "Buy" : "Sell"}
    </span>
  );
}
